import { PageFrame } from '../components/PageFrame';

export function SupportPage() {
  return (
    <PageFrame>
      <section className="page-hero section-shell page-hero--compact">
        <p className="eyebrow">Support</p>
        <h1>We are here when something does not line up.</h1>
        <p>For account access, payment questions, refunds or a missing question balance, contact the Sanjeom support team.</p>
      </section>
      <section className="support-grid section-shell">
        <article className="support-card support-card--primary">
          <p className="eyebrow eyebrow--light">Email support</p>
          <h2>info@ghostprobe.co.uk</h2>
          <p>Include the email on your account and, for payment questions, the Stripe receipt reference. Never send full card details.</p>
          <a className="button button--light" href="mailto:info@ghostprobe.co.uk?subject=Sanjeom%20support">Email support</a>
        </article>
        <article className="support-card">
          <h2>Before you write</h2>
          <ul className="support-list">
            <li><strong>Payment pending:</strong> allow a few minutes, then refresh your workspace.</li>
            <li><strong>Question not returned:</strong> include the date and approximate time.</li>
            <li><strong>Account access:</strong> write from the email connected to the account when possible.</li>
          </ul>
        </article>
        <article className="support-card support-card--company">
          <h2>Service operator</h2>
          <p>GHOSTPROBE LTD</p>
        </article>
      </section>
    </PageFrame>
  );
}
